(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  window.selectCategory = function(button, sectionId) {
    const category = button.getAttribute('data-category');
    const section = document.getElementById('faq-' + sectionId);

    section.querySelectorAll('.faq-category-btn').forEach(btn => {
      btn.classList.remove('active');
    });
    button.classList.add('active');

    section.querySelectorAll('.faq-content').forEach(content => {
      if (content.getAttribute('data-category') === category) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });

    section.querySelectorAll('.faq-answer').forEach(answer => {
      answer.classList.remove('open');
    });
    section.querySelectorAll('.faq-arrow').forEach(arrow => {
      arrow.style.transform = 'rotate(0deg)';
    });
  };

  window.toggleAnswer = function(button) {
    const answer = button.nextElementSibling;
    const arrow = button.querySelector('.faq-arrow');
    const parent = button.closest('.faq-content');

    parent.querySelectorAll('.faq-toggle').forEach(btn => {
      if (btn !== button) {
        const siblingAnswer = btn.nextElementSibling;
        const siblingArrow = btn.querySelector('.faq-arrow');
        siblingAnswer.classList.remove('open');
        siblingArrow.style.transform = 'rotate(0deg)';
      }
    });

    answer.classList.toggle('open');
    if (answer.classList.contains('open')) {
      arrow.style.transform = 'rotate(180deg)';
    } else {
      arrow.style.transform = 'rotate(0deg)';
    }
  };

  } catch(e) { console.error(e); }
})();
})();
